import {
  IParamsObterPesquisaNps,
  IParamsSavePesquisaNps
} from "@/services/shared/pesquisaNPS/type";
import { IPesquisaNpsHandler } from "./protocols/IPesquisaNpsHandler";
import { inject, injectable } from "inversify";
import { DIMixins, DITypes } from "@/core/@types/types";
import { type IPesquisaNpsGateway } from "@/services/shared/pesquisaNPS/IPesquisaNpsGateway";
import { capitalizeFirstLetter } from "@/core/common/utils";
import { type IUserProfileStorageMixin } from "@/core/plugins/storage/UserProfileStorageMixin";
import { IParamsNps, IUserNpsStore } from "@/store/shared/pesquisaNps/types";
import { usePesquisaNpsStore } from "@/store/shared/pesquisaNps/usePesquisaNpsStore";
import { ETipoProduto } from "./types";
import { type IToastNotification } from "@/composables/shared/notification/types";

@injectable()
export default class PesquisaNpsHandler implements IPesquisaNpsHandler {
  @inject(DIMixins.USER_PROFILE_STORAGE)
  userProfileMixin!: IUserProfileStorageMixin;

  @inject(DITypes.PESQUISA_NPS_GATEWAY)
  private pesquisaNpsGateway!: IPesquisaNpsGateway;

  @inject(DITypes.NOTIFICATION)
  private notification!: IToastNotification<string>;

  private userNpsStore: IUserNpsStore = usePesquisaNpsStore();

  private campanhaAtiva = false;

  setNota(value: number | undefined) {
    this.userNpsStore.params.nota = value;
  }

  setComentario(value: string) {
    this.userNpsStore.params.comentario = value;
  }

  setUpdateStep(value: number) {
    this.userNpsStore.params.step = value;
  }

  handleProduto(
    dados: IParamsObterPesquisaNps[] | null | undefined,
    hasContabil: boolean
  ) {
    const isFinancas = !window.location.href.includes("contabil");
    const isContabil = window.location.href.includes("contabil") && hasContabil;

    const produto = isFinancas
      ? ETipoProduto.financas
      : isContabil
      ? ETipoProduto.contabil
      : undefined;

    if (produto == undefined) return false;

    const tipoDoProduto = dados?.find(
      (item: IParamsObterPesquisaNps) => item.tipoCampanha == produto
    );

    if (!tipoDoProduto) return false;

    const nomeDoGrupo =
      this.userProfileMixin.handleGetUserProfile()?.Nome || "";

    this.userNpsStore.params.campanhaId = tipoDoProduto?.campanhaId;
    this.userNpsStore.params.exibirCampanha =
      tipoDoProduto.exibirCampanha || false;
    this.userNpsStore.params.cliente = capitalizeFirstLetter(nomeDoGrupo);
    this.userNpsStore.params.tipoCampanha = tipoDoProduto?.tipoCampanha;

    return tipoDoProduto.exibirCampanha || false;
  }

  async handleUsuario(hasContabil: boolean) {
    const dados = await this.pesquisaNpsGateway.handleObterDadosPesquisa();

    if (!this.userProfileMixin.handleGetUserProfile()) return false;

    const mustShow = this.handleProduto(dados, hasContabil);

    if (!mustShow) return false;

    return mustShow;
  }

  async handleSalvarCampanha() {
    try {
      if (this.userNpsStore.params.nota == undefined) return;

      const params: IParamsSavePesquisaNps = {
        Nota: this.userNpsStore.params.nota,
        Comentario: this.userNpsStore.params.comentario,
        _id: this.userNpsStore.params.campanhaId || ""
      };

      const result = await this.pesquisaNpsGateway.handleSalvarNps(params);

      return result;
    } catch (err) {
      this.notification.showNotification(
        "Erro ao tentar salvar a resposta, tente novamente mais tarde."
      );
    }
  }

  verifyCampanhaAtiva() {
    return this.campanhaAtiva;
  }

  obterCampanhaParams(): IParamsNps {
    return { ...this.userNpsStore.params };
  }
}
